import React from 'react';

import { FlagImg } from './CountryFlag.styles';

/** The round flags, one SVG per ISO 3166-1 alpha-2 code in lower case (`xx` for an unknown country); see the
 *  folder's LICENSE.md. */
const FLAGS_DIR = '/assets/flags';
const UNKNOWN = 'xx';

export type CountryFlagProps = {
  /** An ISO 3166-1 alpha-2 country code, in either case. */
  code: string;
  /** Drawn size in px. */
  size?: number;
};

/**
 * A country's flag as a round SVG picture, the same on every system (an emoji flag reads as two letters on Windows).
 * Decorative: the country's name beside it says which it is. A code with no flag shows the unknown country's.
 */
export const CountryFlag = ({ code, size = 24 }: CountryFlagProps): React.ReactElement => {
  const cc = /^[a-z]{2}$/i.test(code.trim()) ? code.trim().toLowerCase() : UNKNOWN;
  // The code whose flag failed to load (none on the shelf): it shows the unknown country's until the code changes.
  const [failed, setFailed] = React.useState<string | null>(null);
  const shown = failed === cc ? UNKNOWN : cc;
  return (
    <FlagImg
      src={`${FLAGS_DIR}/${shown}.svg`}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
      onError={() => {
        if (shown !== UNKNOWN) setFailed(cc);
      }}
    />
  );
};

export default CountryFlag;
